import { WebService } from "services/web/webService";
import {
  SET_AI_MODEL_CONFIGS,
  SET_AI_MODELS,
  SET_ACTIVE_AI_MODELS,
  IS_AI_MODEL_CONFIG_UPDATING,
  UPDATE_AI_MODEL_CONFIGS,
} from "store/AiFeatures/AiConfigurations/action";
import { SET_CREDIT_BALANCE } from "store/AiFeatures/Credits/action";

export const fetchCreditBalance = (accountId, handleErrorNotification) => {
  return async (dispatch) => {
    try {
      const response = await WebService.get(
        `/accounts/${accountId}/pbx_credits/available_balance`
      );
      dispatch({
        type: SET_CREDIT_BALANCE,
        payload: response.data,
      });
    } catch (error) {
      console.error(error);
      handleErrorNotification(error);
    }
  };
};

export const fetchAiModels = (handleErrorNotification) => {
  return async (dispatch) => {
    try {
      const response = await WebService.get(`ai_model_configs`);

      dispatch({
        type: SET_AI_MODELS,
        payload: response.data?.ai_model_configs,
      });
      return response.data?.ai_model_configs;
    } catch (error) {
      console.error(error);
      handleErrorNotification(error);
    }
  };
};

export const fetchActiveAiModels = (
  accountId,
  params,
  handleErrorNotification
) => {
  return async (dispatch) => {
    try {
      const response = await WebService.get(
        `/accounts/${accountId}/account_ai_model_configs`,
        {
          params: { filters: params },
        }
      );

      dispatch({
        type: SET_ACTIVE_AI_MODELS,
        payload: response.data?.account_ai_model_configs,
      });
    } catch (error) {
      console.error(error);
      handleErrorNotification(error);
    }
  };
};

export const fetchAiModelConfig = (
  accountId,
  aiModelId,
  handleErrorNotification
) => {
  return async (dispatch) => {
    try {
      const response = await WebService.get(
        `/accounts/${accountId}/account_ai_model_configs/${aiModelId}`
      );
      dispatch({
        type: SET_AI_MODEL_CONFIGS,
        payload: { aiModelId: aiModelId, data: response.data },
      });
    } catch (error) {
      console.error(error);
      handleErrorNotification(error);
    }
  };
};

export const updateAiModelConfig = (
  accountId,
  aiModelId,
  id,
  val,
  handleErrorNotification
) => {
  return async (dispatch) => {
    dispatch({
      type: IS_AI_MODEL_CONFIG_UPDATING,
      payload: { config: id, loading: true },
    });
    try {
      const response = await WebService.put(
        `/accounts/${accountId}/account_ai_model_configs/${aiModelId}`,
        { [id]: val }
      );
      if (response.status === 200) {
        dispatch({
          type: UPDATE_AI_MODEL_CONFIGS,
          payload: { id: id, aiModelId: aiModelId, data: val },
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_AI_MODEL_CONFIGS,
        payload: { id: id, aiModelId: aiModelId, data: !val },
      });
      console.error(error);
      handleErrorNotification(error);
    }
    dispatch({
      type: IS_AI_MODEL_CONFIG_UPDATING,
      payload: { config: id, loading: false },
    });
  };
};
